import { Controller } from "@hotwired/stimulus"
import hljs from "highlight.js/lib/core"
import javascript from "highlight.js/lib/languages/javascript"
import ruby from "highlight.js/lib/languages/ruby"
import bash from "highlight.js/lib/languages/bash"
import json from "highlight.js/lib/languages/json"
import yaml from "highlight.js/lib/languages/yaml"
import xml from "highlight.js/lib/languages/xml"
import css from "highlight.js/lib/languages/css"
import plaintext from "highlight.js/lib/languages/plaintext"

hljs.registerLanguage("javascript", javascript)
hljs.registerLanguage("ruby", ruby)
hljs.registerLanguage("bash", bash)
hljs.registerLanguage("json", json)
hljs.registerLanguage("yaml", yaml)
hljs.registerLanguage("xml", xml)
hljs.registerLanguage("html", xml)
hljs.registerLanguage("css", css)
hljs.registerLanguage("plaintext", plaintext)

export default class extends Controller {
  connect() {
    this.element.querySelectorAll("pre code").forEach((block) => {
      hljs.highlightElement(block)
    })
  }
}
